import { MenuObjectTypes } from 'enums/menu';

type MenuItemIdAndType = {
  itemID: string;
  type?: MenuObjectTypes;
};

const menuObjectTypeValues = new Set(Object.values(MenuObjectTypes));

const isMenuObjectType = (value: string): value is MenuObjectTypes =>
  menuObjectTypeValues.has(value as MenuObjectTypes);

export const getItemIdAndType = (id: string): MenuItemIdAndType => {
  const separatorIndex = id.indexOf('-');

  if (separatorIndex === -1) {
    return { itemID: id };
  }

  const type = id.slice(0, separatorIndex);
  if (!isMenuObjectType(type)) {
    return { itemID: id };
  }

  return {
    itemID: id.slice(separatorIndex + 1),
    type,
  };
};
